import React, { useState } from "react";
//import { useLocation } from "wouter";
import { Link, useNavigate } from "react-router-dom";
import useUser from "hooks/useUser";
import { useEffect } from "react";
import csrfService from "services/csrf";
import "./login.css";
import { Container } from "react-bootstrap";
import { Card } from "reactstrap";
import Logo from "components/Logo";
import puntos_naranjas from "../../assets/images/Puntos naranjas-banner actualizaciones.png";
import IconSvg from "assets";

export default function Home({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  //const [, navigate] = useLocation();
  let navigate = useNavigate();
  const { isLoginLoading, hasLoginError, login, isLogged, Roles } = useUser();

  const handleClick = () => {
    navigate("/register");
  };

  return (
    <React.Fragment>
      <div className="home_banner main-content">
        <Container>
          {/* <div className="d-flex justify-content-center align-items-center vh-100"> */}
          <div className="d-flex justify-content-center align-items-top full-height-fix">
            <div className="login text-center">
           
              <Logo className="d-block img-fluid w-75 mx-auto mb-5" />
              <IconSvg.LogoWhite 
                role="button"
                tabIndex="0"
                onClick={handleClick}
                style={{ width: "200px", height: "100px", cursor: "pointer" }}
              />
              

            </div>

            {/* <img src={puntos_naranjas} className="img-fluid" /> */}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}
